import { Helmet } from 'react-helmet-async';

function SEOComponent({ 
  title = 'BUSICONN', 
  description = 'BUSICONN: A social network platform to connect businesses, unskilled or unemployed and skilled personal under one hood', 
  canonicalUrl = 'https://busiconn.com',
  image = '/assets/images/profile.png'  // Make sure this image exists
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="BUSICONN" />

      {/* Twitter Tags */}
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:image" content={image} />
      
      {/* LinkedIn Tags */}
      <meta property="linkedin:title" content={title} />
      <meta property="linkedin:description" content={description} />
      <meta property="linkedin:url" content={canonicalUrl} />
      <meta property="linkedin:image" content={image} />
    </Helmet>
  );
}

export default SEOComponent;